import { render, staticRenderFns } from "./EditorWindow.vue?vue&type=template&id=1518a524"
import script from "./EditorWindow.vue?vue&type=script&lang=js"
export * from "./EditorWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports